export default __webpack_public_path__ + "static/media/Front-End-Libraries.90936db0.png";